import React from "react";
import "./style.scss"
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import  Slider  from "@mui/material/Slider";
import { Formatter } from "utils/formatter";
import Checkbox from '@mui/material/Checkbox';
import { getAllBooks, getBookByCategoryID, getCategories, getHighestPrice, getTargets } from "services/user/bookService";
import { Button } from "@mui/material";
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { FaRegHeart } from "react-icons/fa";
import Pagination from '@mui/material/Pagination';
import { Discount } from "utils/discount";
import { generateSlug, findCategoryIdBySlug } from "utils/createSlug";
import { getBookByAuthorID } from "services/user/bookService";
import { PacmanLoader } from "react-spinners";
function valueText(value) {
    return `${value}°C`;
}
const labelCheckbox = { inputProps: { 'aria-label': 'Checkbox demo' } };

const ProductListing = () => {
    const { slug } = useParams(); // Lấy slug từ URL

    const [isLoading, setIsLoading] = useState(false);

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const [page, setPage] = useState(Number(searchParams.get('page') || 1));
    // const page1 = searchParams.get('page') || 1;
    const sort = searchParams.get("sort") || null;
    const sortOrder = searchParams.get("order") || null;

    const [filters, setFilters] = useState();

    const [priceRange, setPriceRange] = useState([0, 1000000]); // filter price
    const [selectedTargets, setSelectedTargets] = useState([]); // State để lưu mảng target đã chọn

    const [categories, setCategories] = useState([]);
    const [targets, setTargets] = useState([]);
    const [selectedCategoryId, setSelectedCategoryId] = useState(null); // click chọn category trong listing á
    const [books, setBooks] = useState([]);
    // const [page, setPage] = useState(+page1);
    const [totalPage, setTotalPage] = useState(1);

    const navigate = useNavigate();

    const [sortValue, setSortValue] = useState("1"); // giá trị chọn trong sort filter
    useEffect(() => {
        if (sort === "title" && sortOrder === "asc") {
            setSortValue("2")
        }
        else if (sort === "title" && sortOrder === "desc") {
            setSortValue("3")
        }
        else if (sort === "discountedPrice" && sortOrder === "asc") {
            setSortValue("4")
        }
        else if (sort === "discountedPrice" && sortOrder === "desc") {
            setSortValue("5")
        }
        else if (sort === "soldQuantity" && sortOrder === "desc") {
            setSortValue("6")
        }
    }, [sort, sortOrder, setSortValue]);
 
    // getBookByCategoryId
    useEffect(() => {
        const categoryId = findCategoryIdBySlug(categories, slug);
        if (categoryId) {
            setSelectedCategoryId(categoryId);
            
            const fetchBookByCategory = async () => {
                setIsLoading(true)
                let params = { page: page - 1 };
                // nếu có giá trị sort thì thêm zo params
                if (sort && sortOrder) {
                    params.sort = sort;
                    params.order = sortOrder;
                }
                try {
                    const response = await getBookByCategoryID(categoryId, params, filters);
                    setBooks(response.data.content);
                    setTotalPage(response.data.page.totalPages);
                } 
                catch (error) {
                    console.log("fetchBookByCategory", error)
                }
                finally {
                    setIsLoading(false)
                }
                
            };
            fetchBookByCategory();
        }
        else if (slug === "all") {
            setSelectedCategoryId(0); // allBoooks
        }
        else if (!isNaN(+slug)) {
            setSelectedCategoryId(null);

            const fetchBookByAuthor = async () => {
                setIsLoading(true)
                try {
                    const response = await getBookByAuthorID(slug, page - 1);
                    if (response && response.data && response.data.content && response.data.page) {
                        setBooks(response.data.content);
                        setTotalPage(response.data.page.totalPages);
                    }
                } 
                catch (error) {
                    console.log("fetchBookByAuthor", error)
                }
                finally {
                    setIsLoading(false)
                }
            };
            fetchBookByAuthor();    
        } 
        
        window.scrollTo(0, 0);
    }, [slug, page, categories, sort, sortOrder, filters]);

    // getAllBooks
    useEffect(() => {
        if (selectedCategoryId === 0) {
          
          const fetchAllBooks = async () => {
            setIsLoading(true)
            let params = { page: page - 1 };
            // nếu có giá trị sort thì thêm zo params
            if (sort && sortOrder) {
                params.sort = sort;
                params.order = sortOrder;
            }
            try {
                const response = await getAllBooks(params, filters);
                setBooks(response.data.content);
                setTotalPage(response.data.page.totalPages);
            }
            catch (error) {
                console.log("fetchBookByCategory", error)
            }
            finally {
                setIsLoading(false)
            }
          };
    
          fetchAllBooks();
        }
      }, [selectedCategoryId, page, sort, sortOrder, filters]);

    // getCategories
    useEffect(() => {
        const fetchCategories = async () => {
            setIsLoading(true)
            try {
                const response = await getCategories();
                setCategories(response.data); 
            } 
            catch (error) {
                console.error("fetchCategories", error);
            }
            finally {
                setIsLoading(false)
            }
        };

        fetchCategories();
    }, []);

    useEffect(() => {
        const fetchTargets = async () => {
            try {
                const response = await getTargets();
                setTargets(response.data); 
            } 
            catch (error) {
                console.error("fetchTargets:", error);
            }
        };

        fetchTargets();
    }, [])

    // getHighestPrice
    useEffect(() => {
        const fetchHighestPrice = async () => {
            try {
                const response = await getHighestPrice();
                setPriceRange([0, response.data]); 
            } 
            catch (error) {
                console.error("fetchHighestPrice:", error);
            }
        };

        fetchHighestPrice();
    }, [])

    const handleChangePriceRange = (event, newValue) => {
        setPriceRange(newValue);
    };

    const handleChangeTarget = (target) => {
        setSelectedTargets((prevSelectedTargets) => {
            // kiểm tra có id trong mảng được chọn chua
            if (prevSelectedTargets.includes(target.id)) {
                // id có rồi thì xoá
                return prevSelectedTargets.filter(id => id !== target.id);
            } 
            else {
                // id chưa có thì thêm
                return [...prevSelectedTargets, target.id];
            }
        });
    };
    console.log(selectedTargets)

    const handleChangePage = (event, value) => {
        if (selectedCategoryId === 0) {
            setPage(value);
            console.log(sort, sortOrder)
            if (sort && sortOrder) {
                navigate(`/listing/all?page=${value}&sort=${sort}&order=${sortOrder}`);
            }
            else {
                navigate(`/listing/all?page=${value}`);
            }
        }
        // tác giả
        else if (selectedCategoryId === null) {
            setPage(value);
            navigate(`/listing/${slug}?page=${value}`);
        }
        else {
            const category = categories.find(category => category.id === selectedCategoryId);
            const slug = generateSlug(category.name);  
            setPage(value);
            if (sort && sortOrder) {
                navigate(`/listing/${slug}?page=${value}&sort=${sort}&order=${sortOrder}`);
            }
            else {
                navigate(`/listing/${slug}?page=${value}`);
            }
        }
    };

    const handleCategoryClick = (id) => {
        setSortValue("1")
        if (id === 0) {
            setSelectedCategoryId(id);
            navigate(`/listing/all`);
            setPage(1)
        }
        else {
            const category = categories.find(category => category.id === id);
            const slug = generateSlug(category.name); 
            setSelectedCategoryId(id);
            navigate(`/listing/${slug}`);
            setPage(1)
        }
    };

    const handleChangeSort = (event) => {
        const value = event.target.value;
        setSortValue(value);
        if (+value === 2) {
            navigate(`/listing/${slug}?page=${+page}&sort=title&order=asc`)
        }
        else if (+value === 3) {
            navigate(`/listing/${slug}?page=${+page}&sort=title&order=desc`)
        }
        else if (+value === 4) {
            navigate(`/listing/${slug}?page=${+page}&sort=discountedPrice&order=asc`)
        }
        else if (+value === 5) {
            navigate(`/listing/${slug}?page=${+page}&sort=discountedPrice&order=desc`)
        }
        else if (+value === 6) {
            navigate(`/listing/${slug}?page=${+page}&sort=soldQuantity&order=desc`)
        }
    };

    const handleClickFilter = () => {
        setFilters({minPrice: priceRange[0], maxPrice: priceRange[1], targetIDs: selectedTargets})
    }
    
    return (
        <>
            <div className="listingPage">
                <div className="container">
                    <div className="breadcrumb flex-column">
                        <h1>
                            {selectedCategoryId === 0 ? 'Tất cả sản phẩm' : categories.find(category => category.id === selectedCategoryId)?.name || 'Tất cả sản phẩm'}
                        </h1>
                        <ul className="list list-inline d-flex">
                            <li className="list-inline-items">
                                <Link to="/">Trang chủ</Link>
                            </li>
                            <li className="list-inline-items">
                                {/* <Link to="">Tất cả sản phẩm</Link> */}
                                {selectedCategoryId === 0 ? 'Tất cả sản phẩm' : categories.find(category => category.id === selectedCategoryId)?.name || 'Tất cả sản phẩm'}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>


            <div className="listingData">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 sidebarWrapper">
                            <div className="sidebar">
                                <div className="card border-0 shadow">
                                    <h4>Thể loại</h4>
                                    <div className="cateList">
                                        {categories && categories.length > 0 ? (
                                            <>
                                            <div className="cateItem d-flex align-items-center"
                                                onClick={() => handleCategoryClick(0)}    
                                            >
                                                <h5 className="mb-0 me-3"
                                                    style={{
                                                        color: selectedCategoryId === 0 ? '#9d2ff7' : 'black',
                                                        fontWeight: selectedCategoryId === 0 ? 'bold' : 'normal'
                                                    }}
                                                >
                                                    Tất cả sản phẩm
                                                </h5>
                                                <span className="d-flex justify-content-center align-items-center rounded-circle ms-auto">
                                                {categories.reduce((acc, category) => acc + category.quantity, 0)}
                                                </span>
                                            </div>
                                            {categories.map((category) => (
                                                    
                                                    <div className="cateItem d-flex align-items-center"
                                                        key={category.id}
                                                        onClick={() => handleCategoryClick(category.id)}
                                                    >
                                                        <h5 className="mb-0 me-3" 
                                                            style={{
                                                                color: selectedCategoryId === category.id ? '#9d2ff7' : 'black',
                                                                fontWeight: selectedCategoryId === category.id ? 'bold' : 'normal'
                                                            }}
                                                        >{category.name}</h5>
                                                        <span className="d-flex justify-content-center align-items-center rounded-circle ms-auto">{category.quantity}</span>
                                                    </div>
                                           
                                            ))}
                                            </>
                                        ) : (
                                            <li>No categories available</li> 
                                        )}

                                    </div>
                                </div>

                                {/* Filter */}
                                <div className="card border-0 shadow">
                                    <h4>Lọc</h4>
                                    <h6 className="mb-0">Giá</h6>
                                    <Slider
                                        min={0}
                                        step={100000}
                                        max={1000000}
                                        getAriaLabel={() => 'Temperature range'}
                                        value={priceRange}
                                        onChange={handleChangePriceRange}
                                        valueLabelDisplay="auto"
                                        getAriaValueText={valueText}
                                        sx={{
                                            color: '#9d2ff7',
                                            '& .MuiSlider-thumb': {
                                                width: 16,  // Làm nhỏ thumb
                                                height: 16, // Làm nhỏ thumb
                                            },
                                            '& .MuiSlider-track': {
                                                height: 4,  // Làm mỏng track
                                            },
                                            // '& .MuiSlider-rail': {
                                            //     height: 4,  // Làm mỏng rail
                                            // },
                                        }}
                                    />
                                    <div className="d-flex pt-2 pb-2 priceRange">
                                        <span>
                                            Từ:<strong> {Formatter(priceRange[0])}</strong>
                                        </span>
                                        <br/>
                                        <span className="ms-auto">
                                            Đến:<strong> {Formatter(priceRange[1])}</strong>
                                        </span>
                                    </div>

                                    <div className="ageFilter">
                                        <h6>Độ tuổi</h6>
                                        <ul className="list list-inline">
                                            {targets && targets.length > 0 ? (
                                                targets.map(target => (
                                                    <li key={target.id}>
                                                         <label style={{ cursor: 'pointer' }}>
                                                        <Checkbox 
                                                            {...labelCheckbox} 
                                                            checked={selectedTargets.includes(target.id)}  // Kiểm tra xem checkbox có được chọn hay không (some trả vè true fasle )
                                                            onChange={() => handleChangeTarget(target)}
                                                            sx={{
                                                                '& .MuiSvgIcon-root': {
                                                                    fontSize: 20,  // Điều chỉnh kích thước của checkbox (icon)
                                                                },
                                                                '&.Mui-checked': {
                                                                    color: '#9d2ff7',  // màu sau khi check
                                                                },
                                                                }}
                                                        />
                                                        {target.name}
                                                        </label>
                                                    </li>
                                                ))

                                            ) : (
                                                <div></div>
                                            )}
                                            
                                        </ul>
                                    </div>

                                    <Button onClick={handleClickFilter} className="btn-filter">Filter</Button>
                                    
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-9 rightContent">
                            <div className="sort d-flex align-items-center mt-3 mb-3 ms-3">
                                <h3>{(selectedCategoryId === 0 ? 'Tất cả sản phẩm' : categories.find(category => category.id === selectedCategoryId)?.name || 'Tất cả sản phẩm')}</h3>
                                <Box className="ms-auto" sx={{ mr:1.6, minWidth: 120 }}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">Sort</InputLabel >
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={sortValue}
                                            label="Age"
                                            onChange={handleChangeSort}
                                            MenuProps={{
                                                disableScrollLock: true,
                                            }}
                                            sx={{
                                                '&.MuiOutlinedInput-root': {
                                                    // '& fieldset': {
                                                    //     borderColor: 'blue'
                                                    // },
                                                    '&:hover fieldset': {
                                                        borderColor: 'blue',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: '#5E2E86',
                                                    },
                                                },
                                            }}
                                        >
                                        <MenuItem value="1">Mặc định</MenuItem>
                                        <MenuItem value="2">A - Z</MenuItem>
                                        <MenuItem value="3">Z - A</MenuItem>
                                        <MenuItem value="4">Giá tăng dần</MenuItem>
                                        <MenuItem value="5">Giá giảm dần</MenuItem>
                                        <MenuItem value="6">Bán chạy</MenuItem>
                                        </Select>
                                    </FormControl>
                                    </Box>
                            </div>
                            <div className="productRow ms-3">
                            {books && Array.isArray(books) && books.length > 0 ? (
                                books.map(book => (
                                    <div className="item1 productItem1">
                                        <div className="imgWrapper"
                                            onClick={() => navigate(`/details/${book.slug}`)}
                                        >
                                            <img src={book.imageLink} alt={book.title} className='w-100' loading="lazy"/>
                                            { book.originalPrice !== book.discountedPrice ? (
                                                <span className="badge bg-danger">- {Discount(book.originalPrice, book.discountedPrice)}%</span>
                                            ) : (
                                                <span></span>
                                            )}
                                            <div className='actions'>
                                                <Button
                                                    onClick={(e) => { e.stopPropagation();}}>
                                                    <FaRegHeart />
                                                </Button>
                                            </div>
                                            <h4>{book.title}</h4>
                                            {/* <span className='text-success'>In Stock</span> */}
                                            <span  className={book.availableQuantity > 0 ? 'inStock' : 'outOfStock'}>
                                                {book.availableQuantity > 0 ? 'Còn hàng' : 'Hết hàng'}
                                            </span>
                                            <div className="d-flex justify-content-between mt-1">
                                                { book.originalPrice !== book.discountedPrice ? (
                                                    <>
                                                        <span className="curPrice text-danger">{Formatter(book.discountedPrice)}</span>
                                                        <span className="oriPrice">{Formatter(book.originalPrice)}</span>
                                                    </>
                                                ) : (
                                                    <span className="curPrice text-danger">{Formatter(book.discountedPrice)}</span>
                                                )}
                                                {/* <span className="curPrice text-danger">{Formatter(book.discountedPrice)}</span>
                                                <span className="oriPrice">{Formatter(book.originalPrice)}</span> */}
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                // <PacmanLoader color="#5e2e86"/>
                                <div/>
                            )}

                            </div>
                            
                            <div className="pagination justify-content-center mt-5">
                                <Pagination
                                    // key={selectedCategoryId}
                                    count={totalPage} 
                                    color="secondary"
                                    page={page} 
                                    onChange={handleChangePage}
                                />
                            </div>

                        </div>
                    </div>
                </div>
                {isLoading && (
                    <div className="modal">
                        <div className="overlay_loading">
                            <div className="modal-content_loading">
                                <div className="d-flex">
                                <PacmanLoader color="#5e2e86"/>
                                </div>
                            </div>
                        </div>
                    </div>
                )} 
            </div>
        </>
    )
}

export default ProductListing;